import { StorageKey } from "../../../../enums/StorageKey";
import { t } from "@lingui/macro";
import {
    ColRenderer,
} from "../../../../containers/AppPage/Reports/TransactionSummary/Common/helperColRenderer";
import { Type } from "../../../../redux/Transaction/helper";

function getColumns() {
    return [
        {
            title: t`Date`,
            dataIndex: 'date',
            key: 'date',
            sorter: true,
            onCell: ColRenderer.onCell,
            render: (text, record) => ColRenderer.renderDate(
                text, record, record.type || Type.purchase_credit_note),
        },
        {
            title: t`Credit Note`,
            dataIndex: 'number',
            key: 'number',
            sorter: true,
            render: (text, record) => ColRenderer.renderNumber(
                text, record, record.type || Type.purchase_credit_note),
        },
        {
            title: t`Contact`,
            dataIndex: 'contact_name',
            key: 'contact_name',
            sorter: true,
            render: ColRenderer.renderContact,
        },
        {
            title: t`Contact Code`,
            dataIndex: 'contact_code',
            key: 'contact_code',
            sorter: true,
        },
        {
            title: t`Phone No.`,
            dataIndex: 'phone_no',
            key: 'phone_no',
            render: ColRenderer.renderText,
        },
        {
            title: t`Ref No.`,
            dataIndex: 'number2',
            key: 'number2',
            sorter: true,
            render: ColRenderer.renderText,
        },
        {
            title: t`Payment Status`,
            dataIndex: 'payment_status',
            key: 'payment_status',
            render: ColRenderer.renderPaymentStatus,
        },
        {
            title: t`Tags`,
            dataIndex: 'tag_names',
            key: 'tag_names',
            ellipsis: true,
            render: ColRenderer.renderTags,
        },
        {
            title: t`Description`,
            dataIndex: 'description',
            key: 'description',
            ellipsis: true,
            render: ColRenderer.renderText,
        },
        {
            title: t`Currency`,
            dataIndex: 'currency_code',
            key: 'currency_code',
            render: ColRenderer.renderText,
        },
        {
            title: t`Rate`,
            dataIndex: 'exchange_rate',
            key: 'exchange_rate',
            align: 'right',
            render: ColRenderer.renderExchangeRate,
        },
        {
            title: t`Amount`,
            dataIndex: 'base_amount',
            key: 'base_amount',
            align: 'right',
            onCell: ColRenderer.onCell,
            render: ColRenderer.renderBaseAmount,
        },
        {
            title: t`Discount`,
            dataIndex: 'base_discount_amount',
            key: 'base_discount_amount',
            align: 'right',
            onCell: ColRenderer.onCell,
            render: ColRenderer.renderBaseAmount,
        },
        {
            title: t`Tax`,
            dataIndex: 'base_tax_amount',
            key: 'base_tax_amount',
            align: 'right',
            onCell: ColRenderer.onCell,
            render: ColRenderer.renderBaseAmount,
        },
        {
            title: t`Net Amount`,
            dataIndex: 'base_net_amount',
            key: 'base_net_amount',
            align: 'right',
            onCell: ColRenderer.onCell,
            render: ColRenderer.renderBaseAmount,
        },
        {
            title: t`Net Balance`,
            dataIndex: 'base_net_balance',
            key: 'base_net_balance',
            align: 'right',
            onCell: ColRenderer.onCell,
            render: ColRenderer.renderBaseAmount,
        },
        {
            title: t`Ref Net Amount`,
            dataIndex: 'net_amount',
            key: 'net_amount',
            align: 'right',
            render: ColRenderer.renderAmount,
        },
        {
            title: t`Ref Net Balance`,
            dataIndex: 'net_balance',
            key: 'net_balance',
            align: 'right',
            render: ColRenderer.renderAmount,
        },
        {
            title: t`Created`,
            dataIndex: 'created_at',
            key: 'created_at',
            sorter: true,
            width: 180,
            render: ColRenderer.renderCreatedAt,
        },
    ];
}

export default {
    storageKey: StorageKey.report_purchase_credit_note_summary,
    getReportLabel: () => t`Purchase Credit Note Summary`,
    required: [
        'date',
        'number',
        'contact_name',
    ],
    defaulto: [
        'description',
        'base_net_amount',
        'base_net_balance',
    ],
    getColumns,
};
